import { render, staticRenderFns } from "./Mobile.vue?vue&type=template&id=705912a6&scoped=true&"
import script from "./Mobile.vue?vue&type=script&lang=ts&"
export * from "./Mobile.vue?vue&type=script&lang=ts&"
import style0 from "./Mobile.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Mobile.vue?vue&type=style&index=1&id=705912a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705912a6",
  null
  
)

export default component.exports